import type { KeyDict } from 'kiswe-ui'
import type { AdminFanRoomScheduleConfigs, FanRoomSchedule } from '../classes'

export enum FanRoomCsvRowType {
  Athlete = 'Athlete',
  Pair = 'Pair',
  Team = 'Team'
}

export enum FanRoomScheduleConfigType {
  All = 'All',
  Team = 'Team'
}

export enum FanRoomScheduleActionType {
  UpdateOpenState = 'UpdateOpenState',
  SendNotifications = 'SendNotifications'
}

export enum FanRoomScheduleProcessState {
  Failure = 'Failure',
  Pending = 'Pending',
  Started = 'Started',
  Success = 'Success'
}

export interface RoomSchedulesState {
  schedules: KeyDict<FanRoomSchedule>
  scheduleConfigs: AdminFanRoomScheduleConfigs
}
